import { render, staticRenderFns } from "./CommunicationBody.vue?vue&type=template&id=0f6b9f23&scoped=true&"
import script from "./CommunicationBody.vue?vue&type=script&lang=js&"
export * from "./CommunicationBody.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationBody.vue?vue&type=style&index=0&id=0f6b9f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b9f23",
  null
  
)

export default component.exports